import React, { useEffect, useState } from 'react';
import { Layout, Button, Row, Col } from 'antd';
import { CompanyLogo } from 'images';
import { withRouter } from 'react-router-dom';
import UserMenu from './menu';

import './header.css';
import WebSocketService from "../../../services/websocket/WebSocketService";

const { Header: AntHeader } = Layout;
  
const LOGGEDIN_USER_DATA = sessionStorage.LOGGEDIN_USER_DATA
	? JSON.parse(sessionStorage.LOGGEDIN_USER_DATA)
	: null;
const isLoggedIn = LOGGEDIN_USER_DATA === null ? false : true;

const Header = () => {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    // Subscribe to websocket messages
    const unsubscribe = WebSocketService.subscribe((msg) => {
      if (msg.FUNCTION === "CONNECT" && msg.VALUE === "OK") {
        console.log("✅ Connected to WebSocket");
        setConnected(true);
      } else if (msg.FUNCTION === "DISCONNECTED" || msg.FUNCTION === "RECONNECTING") {
        console.log("❌ WebSocket disconnected or reconnecting...");
        setConnected(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="header-container">
      <div className="header-container__left">
        <div className="logo">
          <img
            src={CompanyLogo}
            alt="logo"
            className={connected ? "glow" : ""}
          />
        </div>
        <div className="title">
          <h1 className="font-lg font-bolder">
            {process.env.REACT_APP_HOSPITAL_NAME_BIG}
          </h1>
          <p className="font-sm">
            {process.env.REACT_APP_HOSPITAL_NAME_SMALL} v
            {process.env.REACT_APP_VERSION}
          </p>
        </div>
      </div>

      <div>
        <UserMenu />
      </div>
    </div>
  );
};

export default withRouter(Header);
